import { Table, TableBody } from "@mui/material";
import { MailOutline as ContactIcon } from "@mui/icons-material";
import type { ContactEmails, VendorProfileFacility } from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { formatEmailList, formatText } from "../utils/format";
import { formatPhone } from "../utils/phone";

type Props = {
  profile: VendorProfileFacility;
  contactEmails: ContactEmails;
};

export function ContactNotificationSection({ profile, contactEmails }: Props) {
  return (
    <SectionCard
      icon={<ContactIcon fontSize="small" />}
      title="Contact & Notification"
    >
      <Table size="small">
        <TableBody>
          <FieldRow label="POC Name" value={formatText(profile.poc_name)} />
          <FieldRow
            label="POC Mobile"
            value={formatText(formatPhone(profile.poc_contact, profile.poc_contact_country_code))}
          />
          <FieldRow
            label="POC Designation"
            value={formatText(profile.poc_designation)}
          />
          <FieldRow
            label="Contact Email"
            value={formatText(profile.contact_email)}
          />
          <FieldRow
            label="PO Notification Emails"
            value={formatEmailList(contactEmails.po_notification_emails)}
          />
          <FieldRow
            label="Escalation Emails"
            value={formatEmailList(contactEmails.escalation_emails)}
          />
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default ContactNotificationSection;
